export const FETCH_COMMENTS_REQUEST = 'FETCH_COMMENTS_REQUEST';
export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS';
export const FETCH_COMMENTS_FAILED = 'FETCH_COMMENTS_FAILED';

export const FETCH_ADD_COMMENT_REQUEST = 'FETCH_ADD_COMMENT_REQUEST';
export const FETCH_ADD_COMMENT_SUCCESS = 'FETCH_ADD_COMMENT_SUCCESS';
export const FETCH_ADD_COMMENT_FAILED = 'FETCH_ADD_COMMENT_FAILED';
